<template>
  <div class="web-wrapper">
    <div class="header-wrapper clearfix">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item, index) in aBanner">
            <img
              class="bannerImg"
              :src="item.image"
              :data-jumpurl="item.link_url"
              :data-title="item.name"
              :data-index="index"
            />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <ul class="classes-list">
        <li class="classes-item" v-for="(item, index) in aClasses">
          <img
            :src="item.image"
            alt
            class="class-img"
            @click="classDetail(item.link_url, item.name, index)"
          />
        </li>
      </ul>
    </div>
    <p class="title-wrapper clearfix">
      <button class="change-btn clearfix" @click="changeMessage">
        <img src="../assets/img/webIcon2.png" alt />
        <span>换一批</span>
      </button>
      <img src="../assets/img/webIcon1.png" alt class="title-icon" />
      <span class="box-title">精选内容</span>
    </p>
    <ul class="message-list clearfix">
      <li class="message-item" v-for="(item, index) in aMessage">
        <img
          :src="item.image"
          alt
          class="message-img"
          @click="messageDetal(item.link_url, item.name, index)"
        />
        <p @click="messageDetal(item.link_url, item.name, index)">{{item.name}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import fetch from '../api'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
require('../../static/loading/loading.js')
export default {
  data () {
    return {
      sn: '',
      pn: '',
      category: '',
      messageCateId: '',
      aBanner: [],
      aClasses: [],
      aMessage: [],
      page: 1
    }
  },
  created () {
    this.sn = this.$route.query.sn
    this.pn = this.$route.query.pn
    this.category = this.$route.query.category
    if (this.category) {
      this.fetchCategory()
    }
  },
  mounted () {
    window._hmt.push(['_trackPageview', '/webindex'])
    console.log('部署测试-526')
    // this.fetchCategory()
  },
  methods: {
    // 初始化swiper
    initSwiper () {
      let that = this
      if (this.swiper != null) return
      this.swiper = new Swiper('.swiper-container', {
        centeredSlides: true,
        notNextTick: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        direction: 'horizontal',
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: false
        },
        on: {
          click: function (e) {
            that.bannerDetail(
              e.target.dataset.jumpurl,
              e.target.dataset.title,
              e.target.dataset.index
            )
          }
        }
      })
    },
    // 查询CMS配置的类目
    fetchCategory: function () {
      lnv.pageloading()
      fetch.getCategory().then(res => {
        if (res.statusCode === 200) {
          // 筛选管家专区类目
          var oParent = res.data.filter(item => item.name == this.category)
          var bannerCateId = ''
          var classCateId = ''
          var messageCateId = ''
          oParent[0].children.map(item => {
            if (item.name === 'Banner') {
              bannerCateId = item.id
            } else if (item.name === 'Classes') {
              classCateId = item.id
            } else if (item.name === 'Message') {
              messageCateId = item.id
              this.messageCateId = item.id
            }
          })
          this.getBannerClass(bannerCateId, 'banner')
          this.getBannerClass(classCateId, 'classes')
          this.getMessageContent(messageCateId)
        }
      })
    },
    // 根据类目查询banner和classes内容
    getBannerClass: function (categoryId, type) {
      fetch.getBannerAndClass(categoryId).then(res => {
        lnv.destroyloading()
        if (res.statusCode === 200) {
          if (type === 'banner') {
            this.aBanner = res.data
            this.$nextTick(() => {
              // 下一个UI帧再初始化swiper
              this.initSwiper()
            })
          } else if (type === 'classes') {
            this.aClasses =
              res.data.length > 2 ? res.data.slice(0, 2) : res.data
          }
        }
      })
    },
    // 根据类目查询精选内容（CMS后台配置的message）
    getMessageContent: function (categoryId) {
      fetch.getMessage(categoryId, this.page).then(res => {
        lnv.destroyloading()
        if (res.statusCode === 200) {
          this.aMessage =
            res.data.data.length > 3
              ? res.data.data.slice(0, 3)
              : res.data.data
          if (this.page * 3 < res.data.total) {
            this.page = ++this.page
          } else {
            this.page = 1
          }
        }
      })
    },
    // Banner详情
    bannerDetail: function (url, title, index) {
      let attr = 'PCM-banner' + (parseInt(index) + 1)
      let attrName = 'Banner' + (parseInt(index) + 1)
      //   _hmt.push(['_trackEvent', '点击', attr, attrName])
      window._hmt.push(['_trackEvent', '点击', attr, attrName])
      this.recordClick(url, title, 'Banner')
    },
    // 分类详情
    classDetail: function (url, title, index) {
      let attr = 'PCM-class' + (parseInt(index) + 1)
      let attrName = '分类' + (parseInt(index) + 1)
      //   _hmt.push(['_trackEvent', '点击', attr, attrName])
      window._hmt.push(['_trackEvent', '点击', attr, attrName])
      this.recordClick(url, title, 'Classes')
    },
    // 换一换精选内容
    changeMessage: function () {
      //   _hmt.push(['_trackEvent', '点击', 'PCM-change', '换一批'])
      window._hmt.push(['_trackEvent', '点击', 'PCM-change', '换一批'])
      this.getMessageContent(this.messageCateId)
    },
    // 精选内容详情
    messageDetal: function (url, title, index) {
      let attr = 'PCM-message' + (parseInt(index) + 1)
      let attrName = '文章' + (parseInt(index) + 1)
      window._hmt.push(['_trackEvent', '点击', attr, attrName])
      //   _hmt.push(['_trackEvent', '点击', attr, attrName])
      this.recordClick(url, title, 'Message')
    },
    // 数据埋点
    recordClick: function (url, title, className) {
      // lnv.pageloading()
      // 记录数据库参数：SN，PN，点击时间，模块名称，内容标题
      fetch
        .logWebClick({
          sn: this.sn,
          pn: this.pn,
          name: className,
          title: title
        })
        .then(res => {
          // lnv.destroyloading()
          if (res.statusCode === 200) {
            if (url) {
              window.parent.interactive.openUrl(url)
              // window.open(url)
              // window.location.href = url
            }
          }
        })
    }
  }
}
</script>

<style lang="scss">
.hidden {
  display: none;
}
.lnv-mask-transparent {
  width: 800px;
  height: 506px;
}
.lnv-toast {
  width: 800px;
  height: 506px;
  min-height: 0;
  top: 0;
  left: 0;
  margin-left: 0;
}
.lnv-loading-toast .lnv-toast-content {
  margin-top: 460px;
}
.web-wrapper {
  width: 800px;
  height: 506px;
  margin: 0 auto;
  padding-top: 12px;
  padding-left: 13px;
  text-align: left;
  background: #fff;

  .swiper-container {
    position: relative;
    float: left;
    width: 510px;
    height: 250px;
    border-radius: 10px;
    overflow: hidden;
    background: #e5e5e5;
    img {
      width: 510px;
      height: 250px;
      cursor: pointer;
    }
  }
  .swiper-pagination {
    position: absolute;
    width: 510px;
    height: 14px;
    line-height: 14px;
    bottom: 14px;
    text-align: center;
  }
  .swiper-pagination-bullet {
    position: relative;
    top: -34px;
  }
  .classes-list {
    float: left;
    width: 250px;
    margin-left: 13px;
  }
  .classes-item {
    width: 250px;
    height: 120px;
    border-radius: 8px;
    cursor: pointer;
    img {
      width: 250px;
      height: 120px;
      border-radius: 8px;
    }
  }
  .classes-item:first-child {
    margin-bottom: 10px;
  }
  .title-wrapper {
    height: 48px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    background: #fff;
  }
  .change-btn {
    display: inline-block;
    float: right;
    padding-top: 14px;
    padding-right: 14px;
    border: none;
    outline: none;
    font-size: 14px;
    color: #5c84e7;
    background: none;
    cursor: pointer;
    img {
      float: left;
      width: 18px;
      height: 19px;
      margin-right: 6px;
    }
  }
  .title-icon {
    float: left;
    width: 20px;
    height: 18px;
    margin-right: 4px;
    margin-top: 14px;
  }
  .box-title {
    float: left;
    padding-top: 13px;
  }
  .message-list {
  }
  .message-item {
    float: left;
    width: 248px;
    margin-right: 13px;
    p {
      font-size: 14px;
    }
  }
  .message-img {
    display: block;
    width: 248px;
    height: 140px;
    margin-bottom: 10px;
    border-radius: 8px;
    cursor: pointer;
  }
}
</style>
